export default {
    state: {
        approvals: [],
        approval: [],
        approval_id: null,
        url: '/api/hms/signatures/approvals',
        errors: {},
        table: {
            fields: [
                {key: 'id', label: 'Code', sortable: true},
                {key: 'user', label: 'User', tdClass: 'text-muted'},
                {key: 'from', label: 'From', sortable: true, tdClass: 'text-muted'},
                {key: 'to', label: 'To', sortable: true, tdClass: 'text-muted'},
                {key: 'approved_by', label: 'Approved By', tdClass: 'text-muted'},
                {key: 'status', label: 'Status', tdClass: 'text-muted'},
                {key: 'actions', label: 'Actions', thClass: 'text-center', tdClass: 'text-center'},
            ]
        },
        meta: {
            current_page: 1,
            per_page: "10",
            total: 0,
            from: '',
            to: '',
            sort: 'desc',
            order_by: 'Choose',
            sort_by: 'created_at',
            sort_desc: true,
            search: '',
            page_sizes: [10, 25, 50, 100],
        },
        form: {
            user_id: '',
            from: null,
            to: null,
            notes: '',
        },
    },

    getters: {
        getApprovalTableFields: state => state.table.fields,

        getApprovalsMeta: state => state.meta,

        getApprovalForm: state => state.form,

        getApprovalErrors: state => state.errors,
    },

    mutations: {
        setApprovals: (state, payload) => {
            state.approvals = payload;
        },

        setApprovalsMeta: (state, payload) => {
            state.meta = {...state.meta, ...payload};
        },

        setApprovalErrors: (state, payload) => {
            state.errors = payload;
        },

        setUser: (state, payload) => {
            state.approval_id = payload.approval_id;
            state.approval = payload;
        },

        setApprovalForm: state => {
            state.form = {
                user_id: '',
                from: null,
                to: null,
                notes: '',
            };

            state.errors = {};
        },
    },

    actions: {
        fetchApprovals: ({state, commit}) => {
            let parameters = {
                page: state.meta.current_page,
                per_page: state.meta.per_page,
                sort_by: state.meta.sort_by,
                sort: state.meta.sort,
                search: state.meta.search,
            };

            if (!parameters.search && parameters.search.length <= 3) {
                delete parameters.search;
            }

            return new Promise((resolve, reject) => {
                axios.get(state.url+'?state', {params: parameters})
                    .then(response => {
                        commit('setApprovals', response.data);

                        commit('setApprovalsMeta', response.data.meta);

                        resolve(response.data);
                    })
                    .catch(error => {
                        commit('setApprovalErrors', error.response.data.errors);

                        reject();
                    });
            });
        },

        fetchEditApproval: ({state, commit}, approval_id) => {
            return new Promise((resolve, reject) => {
                axios.get(state.url + '/' + approval_id + '/edit')
                    .then(response => {
                        state.approval_id = response.data.id;

                        state.form = response.data;

                        resolve(response.data);
                    })
                    .catch(error => {
                        reject(error);
                    });
            });
        },

        submitApproval: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setApprovalErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        updateApproval: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.approval_id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setApprovalErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        submitApprovalStatus: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.approval_id + '/status', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setApprovalErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        submitApprovalComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.post(state.url + '/' + state.approval_id + '/comments', payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        if (error.response.data.errors) {
                            commit('setApprovalErrors', error.response.data.errors);
                        }

                        reject(error);
                    });
            })
        },

        updateApprovalComment: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.patch(state.url + '/' + state.approval_id + '/comments/' + payload.id, payload)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        commit('setApprovalErrors', error.response.data.errors);

                        reject();
                    });
            })
        },

        deleteApproval: ({state, commit}, payload) => {
            return new Promise((resolve, reject) => {
                axios.delete(state.url + '/' + payload.approval_id)
                    .then(response => {
                        resolve(response);
                    })
                    .catch(error => {
                        reject(error);
                    });
            })
        },
    }
}
